import { all, take, call, put, takeEvery } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
import { reduxModuleLoaded, requestTiers, requestTiersSuccess } from './actions';
export function fakeTierListResponse() {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        return {
            results: [
                ...deviationsByType.tiers.slice(0, 10)
            ]
        };
    }
}
function* handleFetch() {
    const response = yield call(requestPuppy, {
        method: 'get',
        url: '/tier/user/list'
    }, fakeTierListResponse);
    yield put(requestTiersSuccess(response.results));
}
export default function* userTiersSaga() {
    yield take(reduxModuleLoaded);
    yield all([
        takeEvery(requestTiers, handleFetch)
    ]);
}
